module.exports = __webpack_public_path__ + "media/images/portugal_center/Castelo-de-Leiria-1f3c0e9219eea91632c7abc04fc1a4c5.jpg";